<template>
    <div class='line'  :data-word="clientObj.name" @click='$emit("selectLine")'  >
        <div class='col col1'><a @click='goToClientPage()'>{{ clientObj.name }}</a></div>
        <div class='col col4'>{{ clientObj.code == 'undefined' || clientObj.code == '' ? "&#160;" :  clientObj.code}}</div>
        <div class='col col4'>{{ clientObj.userCount }}</div>
        <div class='col col4'>{{ typeof clientObj.hosts == 'undefined' ? '-' :  clientObj.hosts.length }}</div>
        <div class='col col5'>{{ clientObj.settingsCount }}</div>
        <button v-if="hasIpDisabled" class="mdl-button mdl-js-button mdl-button--icon btn_warning btnWarning" @click='goToIpClientPage()'>
            <i class="material-icons">warning</i>
        </button>
    
        <button class="mdl-button mdl-js-button mdl-button--icon btn_editsub btnEdit" @click='clicToEditClient()'>
            <i class="material-icons">edit</i>
        </button>
        <button class="mdl-button mdl-js-button mdl-button--icon btn_deletesub btnDelete" @click='clicToDeleteClient()'>
            <i class="material-icons">delete</i>
        </button>
    </div> 
</template>

<script>
    import axios from 'axios'
    import FctUtils from '@/components/FctUtils';
    import { diagonalbackURL, defaultConfig } from "../constantes";

    export default {
        name: "ClientLine",
        mixins: [FctUtils],
        data(){
            return {
                firstHostWithIpDisabled: {},
            }
        },
        props:{
            clientObj: {type:Object},
        },
        created() {
            if (typeof this.clientObj.userCount == 'undefined') {
                this.clientObj.userCount = '-';
            }

            if (typeof this.clientObj.settingsCount == 'undefined') {
                this.clientObj.settingsCount = '-';
            }
        },
        computed:{
            hasIpDisabled : function() {
                if (typeof this.clientObj.hosts != 'undefined') {
                    var ips;
                    for (var i = 0; i < this.clientObj.hosts.length; i++) {
                        ips = this.clientObj.hosts[i].authorizedAddress;
                        for (var ip = 0; ip < ips.length; ip++) {
                            if (!ips[ip].active) {
                                this.firstHostWithIpDisabled = this.clientObj.hosts[i];
                                return true;
                            }
                        }
                    }
                }
                return false;
            }
        },
        methods:{
            goToClientPage(){
                this.$router.push({name:"Client", params: {clientId: this.clientObj.id} })
            },
            clicToEditClient() {
                this.emitter.emit('showPLForm', {mode:'formClient_edit', data:this.clientObj});
            },
            clicToDeleteClient() {
                this.emitter.emit('showPLForm', {mode:'formClient_remove', data:this.clientObj});
            },
            //////////////
            goToIpClientPage() {
                if (this.firstHostWithIpDisabled != null && this.firstHostWithIpDisabled != undefined) {
                    // Choisis le client et évite des erreurs dans le store
                    this.$store.dispatch('chooseClient', this.clientObj.id);
                    this.$router.push({name:"Host", params: {hostId: this.firstHostWithIpDisabled.id} })
                }
            },
        }  
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.btnDelete {
    position: absolute;
    top:5px;
    right:5px;
}

.btnWarning {
    position: absolute;
    top:5px;
    right:25px;
}

.btnEdit {
    position: absolute;
    top:5px;
    right:25px;

    color: #0075bb;
}


</style>
